import React from 'react';

function FieldLengthLabel({length, maxLength, style}) {
    return (
        <div style={{
            fontSize: 12,
            color: length == maxLength ? 'red' : 'grey',
            ...style
        }}>
            {length} / {maxLength}
        </div>
    );
}

export default FieldLengthLabel;